const paths = {
  listUsers: '/users/list',
  editUsers: '/users/edit',
  assignUnitsToUser: '/users/assignUnits',
  rolesPermissionsUsers: '/users/rolesPermissions'
};

export default paths;
